import { createNamespacedHelpers } from 'vuex';
import random from 'lodash/random';
import range from 'lodash/range';

const typingActivity = createNamespacedHelpers('activity/typing');
const keyboard = createNamespacedHelpers('keyboard');

export default {
  data() {
    return {
      homerow: ['a', 's', 'd', 'f', 'j', 'k', 'l', ';']
    };
  },

  computed: {
    ...keyboard.mapState(['holdKeyPressed']),
    ...typingActivity.mapGetters(['isTouchHold', 'targetKey'])
  },

  watch: {
    holdKeyPressed() {
      if (this.handleHoldKey) this.handleHoldKey();
    }
  },

  methods: {
    useHomeRowLetter(currentLettersIndex) {
      return currentLettersIndex % 2 !== 0;
    },

    getRandomHomeRowLetter() {
      return this.homerow[random(this.homerow.length - 1)];
    },

    getRandomLetter(letters) {
      return letters[random(letters.length - 1)].toLowerCase();
    },

    shuffleLetters(letters, steps, shuffler) {
      return range(steps).map(shuffler);
    },

    shuffleWithHomerow(letters) {
      // eslint-disable-next-line no-confusing-arrow
      return i =>
        this.useHomeRowLetter(i)
          ? this.getRandomLetter(this.homerow)
          : this.getRandomLetter(letters);
    }
  }
};
